// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1TH90","bigColWidth":"Table_bigColWidth__22vTK","biggerColWidth":"Table_biggerColWidth__26iCW","row":"Table_row__3ZKLm","col":"Table_col__3fwRI"};